import {
  effect,
  inject,
  Injectable,
  signal,
  Signal,
  WritableSignal,
} from '@angular/core';
import { Event, eventConverter } from 'src/app/models/event.model';
import { AuthService } from '../auth.service';
import {
  collection,
  collectionData,
  Firestore,
  orderBy,
  query,
  where,
} from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root',
})
export class EventsStoreService {
  private firestore = inject(Firestore);
  private _auth: AuthService = inject(AuthService);
  private _events: WritableSignal<Event[]> = signal<Event[]>([]);
  events: Signal<Event[] | undefined> = this._events.asReadonly();

  constructor() {
    const eventsCollection = collection(this.firestore, 'events').withConverter(
      eventConverter,
    );
    effect(() => {
      const user = this._auth.user();
      if (!user) {
        this._events.set([]);
      } else if (user.roles.admin) {
        const q = query(eventsCollection, orderBy('startTime', 'desc'));
        collectionData(q, { idField: 'id' }).subscribe((events) => {
          this._events.set(events);
        });
      } else {
        const q = query(
          eventsCollection,
          where('organizerIds', 'array-contains', user.uid),
          orderBy('startTime', 'desc'),
        );
        collectionData(q, { idField: 'id' }).subscribe((events) => {
          this._events.set(events);
        });
      }
    });
  }
}
